/**
 *  @class
 *  @function BackgroundVideo
 */
if (!customElements.get('background-video')) {
	class BackgroundVideo extends HTMLElement {
		constructor() {
			super();
		}
		connectedCallback() {
			let _this = this;
			if (document.body.classList.contains('animations-true') && typeof gsap !== 'undefined') {
				this.prepareAnimations();
			}
			// Dual playlist: Shopify+Shopify, or YouTube+Shopify 2
			this.setupPlaylist();
			// Video Support.
			let video_container = this.querySelector('.background-video__iframe');
			if (video_container) {
				if (video_container.querySelector('iframe') && !this.querySelector('[data-cc-mix-playlist]')) {
					video_container.querySelector('iframe').onload = function () {
						_this.videoPlay(video_container);
					};
				}
			}
		}
		setupPlaylist() {
			const root = this.querySelector('[data-cc-video-playlist]');
			if (!root) return;

			if (root.hasAttribute('data-cc-mix-playlist')) {
				this.setupMixPlaylist(root);
				return;
			}

			const videos = Array.prototype.slice.call(root.querySelectorAll('video'));
			if (videos.length < 2) return;

			let index = 0;
			videos.forEach(function (video) {
				video.muted = true;
				video.defaultMuted = true;
				video.playsInline = true;
				video.setAttribute('playsinline', '');
				video.loop = false;
				video.removeAttribute('loop');
			});

			const playAt = function (nextIndex) {
				videos.forEach(function (video, i) {
					video.classList.toggle('is-active', i === nextIndex);
					if (i !== nextIndex) {
						try {
							video.pause();
						} catch (e) {}
					}
				});
				const active = videos[nextIndex];
				active.currentTime = 0;
				const playPromise = active.play();
				if (playPromise && typeof playPromise.catch === 'function') {
					playPromise.catch(function () {});
				}
			};

			videos.forEach(function (video) {
				video.addEventListener('ended', function () {
					index = (index + 1) % videos.length;
					playAt(index);
				});
			});

			playAt(0);
		}
		setupMixPlaylist(root) {
			const ytSlide = root.querySelector('[data-cc-slide="youtube"]');
			const hostedSlide = root.querySelector('[data-cc-slide="hosted"]');
			const iframe = ytSlide ? ytSlide.querySelector('iframe') : null;
			const hosted = hostedSlide ? hostedSlide.querySelector('video') : null;
			if (!iframe || !hosted) return;

			hosted.muted = true;
			hosted.defaultMuted = true;
			hosted.playsInline = true;
			hosted.setAttribute('playsinline', '');
			hosted.loop = false;
			hosted.removeAttribute('loop');

			let index = 0; // 0 = youtube, 1 = hosted
			const origin = 'https://www.youtube.com';

			const setActive = function (nextIndex) {
				index = nextIndex;
				ytSlide.classList.toggle('is-active', nextIndex === 0);
				hostedSlide.classList.toggle('is-active', nextIndex === 1);
			};

			const ytCommand = function (func, args) {
				try {
					iframe.contentWindow.postMessage(
						JSON.stringify({ event: 'command', func: func, args: args || [] }),
						origin
					);
				} catch (e) {}
			};

			const playYoutube = function () {
				setActive(0);
				try {
					hosted.pause();
				} catch (e) {}
				ytCommand('seekTo', [0, true]);
				ytCommand('playVideo');
			};

			const playHosted = function () {
				setActive(1);
				ytCommand('pauseVideo');
				hosted.currentTime = 0;
				const playPromise = hosted.play();
				if (playPromise && typeof playPromise.catch === 'function') {
					playPromise.catch(function () {});
				}
			};

			hosted.addEventListener('ended', function () {
				playYoutube();
			});

			const onMessage = function (event) {
				if (event.origin !== origin) return;
				let data = event.data;
				if (typeof data === 'string') {
					try {
						data = JSON.parse(data);
					} catch (e) {
						return;
					}
				}
				if (!data) return;
				// Ended
				if (data.event === 'onStateChange' && Number(data.info) === 0 && index === 0) {
					playHosted();
				}
			};
			window.addEventListener('message', onMessage);

			const startListening = function () {
				try {
					iframe.contentWindow.postMessage(
						JSON.stringify({ event: 'listening', id: iframe.id || 'cc-bg-yt' }),
						origin
					);
				} catch (e) {}
				ytCommand('addEventListener', ['onStateChange']);
				playYoutube();
			};

			if (iframe.dataset.src && !iframe.getAttribute('src')) {
				iframe.addEventListener(
					'load',
					function () {
						startListening();
					},
					{ once: true }
				);
				// lazySizes / native: ensure src is applied
				iframe.setAttribute('src', iframe.dataset.src);
			} else if (iframe.getAttribute('src')) {
				if (iframe.contentWindow) {
					startListening();
				} else {
					iframe.addEventListener('load', startListening, { once: true });
				}
			} else {
				iframe.addEventListener('load', startListening, { once: true });
			}
		}
		videoPlay(video_container) {
			setTimeout(() => {
				if (video_container.dataset.provider === 'youtube') {
					video_container.querySelector('iframe').contentWindow.postMessage(JSON.stringify({ event: "command", func: "playVideo", args: "" }), "*");
				} else if (video_container.dataset.provider === 'vimeo') {
					video_container.querySelector('iframe').contentWindow.postMessage(JSON.stringify({ method: "play" }), "*");
				}
			}, 10);
		}
		prepareAnimations() {
			let section = this,
				tl = gsap.timeline({
					scrollTrigger: {
						trigger: section,
						start: "top center",
						end: "bottom bottom"
					}
				}),
				button_offset = 0;

			document.fonts.ready.then(function () {
				new SplitText(section.querySelectorAll('h3, p'), {
					type: 'lines, words',
					linesClass: 'line-child'
				}
				);

				if (section.querySelector('h3')) {
					let h3_duration = 0.7 + ((section.querySelectorAll('h3 .line-child div').length - 1) * 0.05);
					tl
						.from(section.querySelectorAll('h3 .line-child div'), {
							duration: h3_duration,
							yPercent: '100',
							stagger: 0.05
						}, 0);
					button_offset += h3_duration;
				}
				if (section.querySelector('p')) {
					let p_duration = 0.7 + ((section.querySelectorAll('p .line-child div').length - 1) * 0.02);
					tl
						.from(section.querySelectorAll('p .line-child div'), {
							duration: p_duration,
							yPercent: '100',
							stagger: 0.02
						}, 0);
					button_offset += p_duration;
				}
				if (section.querySelector('.video-lightbox-modal__button')) {
					tl.fromTo(section.querySelector('.video-lightbox-modal__button'), {
						autoAlpha: 0
					}, {
						duration: 0.5,
						autoAlpha: 1
					}, button_offset * 0.4);
				}

			});
		}
	}
	customElements.define('background-video', BackgroundVideo);
}
